import i18n from "~/plugins/i18n";

function initDataImageExtra(totalImages) {
  return Array.from({ length: totalImages }, (_, i) => ({
    id: i + 1,
    name: i18n.t('image_number', { number: i + 1 }),
    image: null,
    details: '',
    custom_legends: false,
    legends: []
  }))
}

export function mapSection(section) {
  const totalImages = section.numberOfExtraImages || 0;
  const documentType = section.documentType || null;
  return {
    id: section.id,
    name: section.name,
    code: section.code,
    print: section.visible, // esto taves deba venir su propia variable si es necesario modificar aqui
    visible: section.visible,
    disabled: !section.canDisableSection,
    // withWeekly: false, // Esta propiedad no se usa en la configuracion de secciones, por lo que se inicializa como false no se sabe para que es talvez para determinar si se calcula progreso semanal borrar si no se usa mas adelante
    weeklyRange: [], // esta bariable talvez no se usa eliminar si fuera el caso (verificar antes de eliminar)
    weeklyRangeForm: [], // esta bariable talvez no se usa eliminar si fuera el caso (verificar antes de eliminar)
    count: totalImages, // por ahora lo manejamos de esta forma al parecer es la cantidad de imagenes pero hay redundancio con totalImage luego depurar para limpiar
    // fixed: false, // propiedad no usada borrar mas adelante
    with_drawing: documentType === 'drawing',
    drawing_image: '',
    with_activity_document: documentType === 'activity_document',
    activity_image: '',
    with_pictograms: section.withPictograms ?? false, // esta propiedad es una bandera para back si calcula pictogramas, debugear puede que no sea necesario de momento no se hace uso est comentado
    hasAssociatedGroup: section.hasAssociatedGroup ?? false,
    associatedGroupId: section.groupId ?? null,
    is_evacuation_line: false,
    with_status: section.userCanDefineLegend ?? false,
    // Orientación de la página del Gantt en el PDF (solo aplica a la sección GANTT).
    // false = vertical (default), true = horizontal. Valor inicial desde la config;
    // si gantt_user_can_change_orientation está activo el usuario puede cambiarlo al generar.
    gantt_landscape: section.ganttLandscape ?? false,
    // Si es true, la form de generación muestra el selector de orientación; si no, queda oculto.
    gantt_user_can_change_orientation: section.ganttUserCanChangeOrientation ?? false,
    status_oc: [],
    subactivities: [],
    documents: [],
    totalImages,
    images: totalImages ? initDataImageExtra(totalImages) : [],
    // is_evacuation_line: section.isEvacuationLine ?? false, //  es bandera para hucar en el back debuguear si se usa o no realmente esta comentado de momento
  }
}